import React from 'react';
import { Telephone, Envelope } from 'react-bootstrap-icons';
import '../../views/EjecutivoView.css';

const SubSecretaria = ({ item, dependeIntendencia = false }) => {
  return (
    <>
      {item != null && (
        <div className={`ejecutivo-box ${dependeIntendencia ? 'secretaria' : 'subSecretaria'}`}>
          <div className="ejecutivo-linea"></div>
          <div className="ejecutivo-nombre">Subsecretaría de {item.nombre}</div>
          <div className="ejecutivo-sub">{item.subSecretarioNombre}</div>
          <div className="ejecutivo-sub">
            <Envelope />{' '}
            <a className="ejecutivo-link" href={'mailto:' + item.subSecretarioEmail}>
              {item.subSecretarioEmail}
            </a>
          </div>
          <div className="ejecutivo-sub">
            <Telephone /> Teléfono {item.subSecretarioTelefono}
          </div>
        </div>
      )}
    </>
  );
};

export default React.memo(SubSecretaria);
